import { render, staticRenderFns } from "./NoteAdd.vue?vue&type=template&id=19201864&"
import script from "./NoteAdd.vue?vue&type=script&lang=js&"
export * from "./NoteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports